export const ORDER_TYPE = {
  DELIVERY: "D",
  TAKEAWAY: "T",
  PICKUP: "P",
  DINEIN: "DINEIN",
  CURB: "CURB",
};

export const ORDER_STATUS_LONG_HISTORY = {
  [ORDER_TYPE.DELIVERY]: "Delivered",
  [ORDER_TYPE.TAKEAWAY]: "Picked up",
  [ORDER_TYPE.PICKUP]: "Picked up",
  [ORDER_TYPE.IRCTC]: "Delivered",
  [ORDER_TYPE.DINEIN]: "Picked up",
  [ORDER_TYPE.CURB]: "Picked up",
};

export const OrderStatusCode = {
  [ORDER_TYPE.DELIVERY]: {
    1: "Order Confirmed",
    2: "Being Prepared",
    4: "Dispatched",
    5: "Cancelled",
    9: "Delivered",
    10: "Advance Order",
  },
  [ORDER_TYPE.TAKEAWAY]: {
    1: "Order Confirmed",
    2: "Being Prepared",
    4: "Order is ready",
    5: "Cancelled",
    9: "Picked Up",
    10: "Advance Order",
  },
  [ORDER_TYPE.PICKUP]: {
    1: "Order Confirmed",
    2: "Being Prepared",
    4: "Order is ready",
    5: "Cancelled",
    9: "Picked Up",
    10: "Advance Order",
  },
  [ORDER_TYPE.CURB]: {
    1: "Order Confirmed",
    2: "Being Prepared",
    4: "Order is ready",
    5: "Cancelled",
    9: "Picked Up",
    10: "Advance Order",
  },
  [ORDER_TYPE.DINEIN]: {
    1: "Order Confirmed",
    2: "Being Prepared",
    4: "Order is ready",
    5: "Cancelled",
    9: "Served",
    10: "Advance Order",
  },
};

export const OrderStatusBgColor = {
  [ORDER_TYPE.DELIVERY]: {
    1: "bg-yellow",
    2: "bg-yellow",
    4: "bg-yellow",
    5: "bg-red",
    9: "bg-green",
    10: "bg-blue",
  },
  [ORDER_TYPE.TAKEAWAY]: {
    1: "bg-yellow",
    2: "bg-yellow",
    4: "bg-yellow",
    5: "bg-red",
    9: "bg-green",
    10: "bg-blue",
  },
  [ORDER_TYPE.PICKUP]: {
    1: "bg-yellow",
    2: "bg-yellow",
    4: "bg-yellow",
    5: "bg-red",
    9: "bg-green",
    10: "bg-blue",
  },
  [ORDER_TYPE.CURB]: {
    1: "bg-yellow",
    2: "bg-yellow",
    4: "bg-yellow",
    5: "bg-red",
    9: "bg-green",
    10: "bg-blue",
  },
  [ORDER_TYPE.DINEIN]: {
    1: "bg-yellow",
    2: "bg-yellow",
    4: "bg-yellow",
    5: "bg-red",
    9: "bg-green",
    10: "bg-blue",
  },
};

export const OrderStatusTimelineConstantsForDelivery = [
  {
    id: 1,
    text: "Confirmed",
  },
  {
    id: 2,
    text: "Being Prepared",
  },
  {
    id: 4,
    text: "Out for Delivery",
  },
  {
    id: 9,
    text: "Delivered",
  },
];

export const OrderStatusTimelineConstantsForTakeAway = [
  {
    id: 1,
    text: "Confirmed",
  },
  {
    id: 2,
    text: "Being Prepared",
  },
  {
    id: 4,
    text: "Ready",
  },
  {
    id: 9,
    text: "Picked Up",
  },
];

export const OrderStatusTimelineConstantsForDinein = [
  {
    id: 1,
    text: "Confirmed",
  },
  {
    id: 2,
    text: "Being Prepared",
  },
  {
    id: 4,
    text: "Ready",
  },
  {
    id: 9,
    text: "Picked Up",
  },
];

export const DISABLED_ORDER_TYPE = {
  DINE_IN: "DINEIN",
  DELIVERY: "D",
  PICKUP: "P",
};
